<app-authentication></app-authentication>
<app-alerts></app-alerts>
<app-layout [style.display]="systemConfigLoaded ? 'block' : 'none'"></app-layout>
<div kendoDialogContainer></div>